import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog';
import QRCodeScanner from '@/components/ui/html5qrcode/QRCodeScanner';

interface QRScannerDialogProps {
  open: boolean;
  onToggleOpen: (code?: string) => void;
}

export function QRScannerDialog({ open, onToggleOpen }: QRScannerDialogProps) {
  const onNewScanResult = (decodedText: string) => {
    if (decodedText) {
      onToggleOpen(decodedText);
    }
  };
  const handleToggleOpenState = () => {
    onToggleOpen();
  };

  return (
    <Dialog open={open} onOpenChange={handleToggleOpenState}>
      <DialogContent className="flex h-[100dvh] max-h-[100dvh] w-screen min-w-full flex-col overflow-y-auto rounded-none">
        <DialogHeader>
          <DialogTitle>Serial Scanner</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <div className="flex h-full w-full items-center justify-center">
          <div className="w-full lg:max-w-xl">
            <QRCodeScanner onSuccess={onNewScanResult} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
